<template>
    <div class="terms">
        <!--Text for user terms of service-->
        <div class="modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h4 class="modal-title ml-2">Privacy Policy</h4>
                        <button class="close text-white" data-dismiss="modal" :style="close" aria-label="Close" @click="close">
                            <span aria-hidden="true"><h4><cancel-icon class="close-icon" style="height: 35px !important;width: 35px !important;color: #fff;"></cancel-icon></h4></span>
                        </button>
                    </div>
                    <div class="modal-body" style="overflow-y: scroll;">
                        <p><strong>Effective Date:</strong> 01 June 2025</p>

                        <p>Your privacy is important to us. This Privacy Policy explains how <strong>Fusion</strong> ("we", "our", or "us") collects, uses, discloses, and protects your personal information when you use our Digital Asset Management (DAM) web application (the "Service").</p>

                        <h4>1. Information We Collect</h4>

                        <p><strong>Account Information:</strong> When you create an account, we collect your name, email address, organization name, and password.</p>
                        <p><strong>Uploaded Content:</strong> We collect and store files (e.g., images, videos, documents) and metadata that you upload to the platform.</p>
                        <p><strong>Usage Data:</strong> We may collect information about how you access and use the Service, including IP address, browser type, pages viewed, and session duration.</p>
                        <p><strong>Cookies & Tracking:</strong> We use cookies and similar technologies to enhance user experience and analyze usage.</p>

                        <h4>2. How We Use Your Information</h4>
                        <p>We use the collected information to:</p>
                        <ul>
                            <li>Provide and improve the Service</li>
                            <li>Personalize your experience</li>
                            <li>Communicate with you (e.g., support, updates, security notices)</li>
                            <li>Enforce our Terms and prevent abuse</li>
                            <li>Comply with legal obligations</li>
                        </ul>

                        <h4>3. Sharing of Information</h4>
                        <p>We do <strong>not sell</strong> your personal information. We may share your data with:</p>
                        <ul>
                            <li>Trusted third-party service providers (e.g., cloud storage, analytics)</li>
                            <li>Authorities, if required by law or to protect rights and safety</li>
                            <li>Other users in your organization, depending on access settings</li>
                        </ul>

                        <h4>4. Data Security</h4>
                        <p>We implement industry-standard security measures to protect your information. However, no method of transmission or storage is 100% secure.</p>

                        <h4>5. Data Retention</h4>
                        <p>We retain your data as long as your account is active or as needed to provide the Service. You can request deletion of your data at any time.</p>

                        <h4>6. Your Rights</h4>
                        <p>You have the right to:</p>
                        <ul>
                            <li>Access and update your personal information</li>
                            <li>Request deletion of your data</li>
                            <li>Withdraw consent at any time</li>
                            <li>Object to certain data uses</li>
                        </ul>
                        <p>To exercise these rights, please contact us at <a href="mailto:support@workflowlabs.com">support@workflowlabs.com</a>.</p>

                        <h4>7. Third-Party Services</h4>
                        <p>Our Service may include integrations with third-party tools. Their use of your information is governed by their own privacy policies.</p>

                        <h4>8. Children’s Privacy</h4>
                        <p>Our Service is not intended for individuals under the age of 18. We do not knowingly collect personal data from children.</p>

                        <h4>9. International Transfers</h4>
                        <p>If you are accessing the Service from outside India, your data may be transferred to and processed in India or other countries where our service providers operate.</p>

                        <h4>10. Changes to This Policy</h4>
                        <p>We may update this Privacy Policy from time to time. You will be notified of any material changes via email or in-app notification.</p>

                        <h4>11. Contact Us</h4>
                        <p>If you have any questions or concerns about this Privacy Policy, contact us at:</p>
                        <ul>
                            <li><strong>Email:</strong> <a class="link" href="mailto:support@workflowlabs.com">support@workflowlabs.com</a></li>
                            <li><strong>Mailing Address:</strong> S. G. Towers, 2M-425, 2nd Main Rd, B Channasandra, East of NGEF Layout, Kasturi Nagar, Bengaluru, Karnataka 560043</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import cancelIcon from "../core/InlineCancelField.vue"
export default {
    name: 'policy',
    data() {
        return {
            parentRouteInfo:{},
            isClosed: false,
        };
    },
    components: {
        'cancel-icon':cancelIcon,
    },
    methods: {
        close() {
            this.isClosed = true
            if (Object.keys(this.parentRouteInfo)!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
              this.$router.push({
                name: this.parentRouteInfo.name,
                params:this.parentRouteInfo.params,
                query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
              })
            }else{
                if (this.$route.path.includes("explorer")) {
                    this.$router.push({
                        name: "explorer",
                    })
                } else {
                    this.$router.push({name:"login"})
                }
            }
        }
    },
    created() {
        Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
    }
};
</script>
<style scoped lang="scss">
$border-color: 1px solid #4a4a4a;
$border-color-only:#4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$none-text-color:#4f4f4f;
$input-field-padding:.375rem 10px;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;
$tags-background-color:#282d31;
$tags-border-color:#363636;
$metadata-border-color-on-hover: #5a5a5a;
$secondary-border-color: 1px solid #2b2b2b;
$active-green-color:#28a745;
$svg-color:#666;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$icon-hover:#2c3339;

.modal{
    display:block;        
}

.modal-title{
    margin-top:10px !important;
}

.modal-dialog {
    max-width:100%;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}

.modal-content {
    height: 100%;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    pointer-events: all;
    background:$primary-background !important;
}

.modal-header,.modal-footer{
    border: $secondary-border-color !important;
    background: $secondary-background-color;
}
  
.modal-header{
    height:65px;
}
.modal-body {
    height:calc(100% - 65px);
    display:inline-block;
    width:100%;
  
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}
h4 {
    text-align: start;
}
p {
    text-align: start;
}
li {
    list-style: none;
    text-align: start;
    padding-inline-start: 1rem;
}
/* width */
::-webkit-scrollbar {
  width: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #141414;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #333;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.link,
.link:hover {
    color: #1d9bd1;
}
</style>